function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "144px",
    height: "144px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#191920",
    d: "M 59.5,-0.5 C 67.5,-0.5 75.5,-0.5 83.5,-0.5C 115.833,7.16667 135.833,27.1667 143.5,59.5C 143.5,67.5 143.5,75.5 143.5,83.5C 135.833,115.833 115.833,135.833 83.5,143.5C 75.5,143.5 67.5,143.5 59.5,143.5C 27.1667,135.833 7.16667,115.833 -0.5,83.5C -0.5,75.5 -0.5,67.5 -0.5,59.5C 7.16667,27.1667 27.1667,7.16667 59.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 25.5,30.5 C 35.3247,29.3417 45.3247,29.1751 55.5,30C 62.0066,38.6676 68.6733,47.1676 75.5,55.5C 82.8045,47.1921 90.1378,38.8588 97.5,30.5C 102.467,29.3377 107.467,29.1711 112.5,30C 102.167,41.6667 91.8333,53.3333 81.5,65C 93.6214,80.7436 105.621,96.5769 117.5,112.5C 108.184,113.665 98.8511,113.832 89.5,113C 82,103.5 74.5,94 67,84.5C 58.6172,94.0942 50.1172,103.594 41.5,113C 36.8333,113.667 32.1667,113.667 27.5,113C 38.8845,100.871 49.5511,88.2044 59.5,75C 48.7007,59.7082 37.3673,44.8748 25.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#201f26",
    d: "M 42.5,38.5 C 46.3927,36.7606 49.8927,37.4273 53,40.5C 68.8333,61.6667 84.6667,82.8333 100.5,104C 97.7728,104.818 95.1062,104.652 92.5,103.5C 75.7783,81.7907 59.1117,60.124 42.5,38.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterX);
export default __webpack_public_path__ + "static/media/twitter-x.35fa707ab2918a09fb60412fb1adf3be.svg";
export { ForwardRef as ReactComponent };